import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router";
import { CodeBox } from "@ory/elements";
import { ory } from "@services/authentication";

export const Error = () => {
  const [error, setError] = useState<string>();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const queryError = searchParams.get("error");
    if (queryError !== null) {
      try {
        // oxlint-disable-next-line react-hooks/set-state-in-effect
        setError(
          JSON.stringify(JSON.parse(decodeURIComponent(queryError)), null, 2),
        );
      } catch (e) {
        console.log(e);
        setError(queryError);
      }
    } else {
      setError("Undefined error");
    }
    const errorId = searchParams.get("id");
    if (errorId !== null) {
      ory()
        .getFlowError({ id: errorId })
        .then((res) => {
          const error = res.data.error;
          if (!error) {
            setError("An error occured.");
            return;
          }
          if ("reason" in error && typeof error.reason === "string") {
            setError(error.reason);
          }
        });
    }
  }, [searchParams]);

  return (
    <>
      <Link to="/">Home</Link>
      <p>
        An error occurred. Please check the error information below and try
        again.
      </p>
      <CodeBox className="overflow-auto max-w-2xl">{error}</CodeBox>
    </>
  );
};
